<template>
  <div class="min-h-screen bg-white">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 mx-auto">
      <!-- Colonne de gauche - Récapitulatif Skeleton -->
      <div class="order-1 px-4 sm:px-6 lg:pl-15 xl:pl-60 pr-5 py-2 lg:py-14">
        <div class="sticky top-8">
          <!-- Mobile Header Skeleton -->
          <div class="lg:hidden space-y-4">
            <!-- Badge organisation -->
            <div class="flex items-center">
              <div class="w-36 h-7 bg-gray-200 rounded-full animate-pulse"></div>
            </div>

            <!-- Bannière image avec overlay - Skeleton -->
            <div class="relative rounded-[40px] overflow-hidden shadow-lg">
              <div class="w-full h-48 bg-gray-200 animate-pulse"></div>
            </div>

            <!-- Progression compacte - Skeleton -->
            <div class="bg-gray-50 rounded-xl p-4 shadow-md">
              <div class="flex justify-between items-center mb-2">
                <div class="w-24 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div class="w-20 h-4 bg-gray-200 rounded animate-pulse"></div>
              </div>
              <div class="w-full h-2 bg-gray-200 rounded-full animate-pulse"></div>
            </div>
          </div>

          <!-- Version Desktop -->
          <div class="hidden lg:block mt-8">
            <!-- Badge organisation -->
            <div class="flex items-center mb-4">
              <div class="w-36 h-7 bg-gray-200 rounded-full animate-pulse"></div>
            </div>

            <!-- Titre principal -->
            <div class="w-56 h-7 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div class="w-28 h-9 bg-gray-200 rounded animate-pulse mb-6"></div>

            <!-- Détails -->
            <div class="space-y-4 mb-6">
              <div class="flex justify-between py-2">
                <div class="w-40 h-5 bg-gray-200 rounded animate-pulse"></div>
                <div class="w-16 h-5 bg-gray-200 rounded animate-pulse"></div>
              </div>

              <!-- Image de la campagne - Skeleton -->
              <div class="rounded-xl overflow-hidden shadow-lg">
                <div class="w-full h-40 bg-gray-200 animate-pulse"></div>
              </div>

              <!-- Progression de la campagne - Skeleton -->
              <div class="bg-gray-50 rounded-xl p-4">
                <div class="flex justify-between items-end mb-2">
                  <div class="w-32 h-6 bg-gray-200 rounded animate-pulse"></div>
                  <div class="w-24 h-4 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div class="w-full h-2 bg-gray-200 rounded-full animate-pulse"></div>
              </div>
            </div>

            <!-- Sous-total et total -->
            <div class="border-t border-gray-200 pt-4">
              <div class="flex justify-between py-2">
                <div class="w-20 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div class="w-16 h-4 bg-gray-200 rounded animate-pulse"></div>
              </div>

              <div class="w-48 h-4 bg-gray-200 rounded animate-pulse mt-4"></div>

              <!-- Total -->
              <div class="flex justify-between py-3 border-t border-gray-200 mt-4">
                <div class="w-36 h-5 bg-gray-200 rounded animate-pulse"></div>
                <div class="w-20 h-5 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Colonne de droite - Formulaire Skeleton -->
      <div class="order-2 px-4 sm:px-6 lg:px-14 pb-6 lg:py-14 shadow-2xl">
        <div class="max-w-md mx-auto lg:mx-0">
          <!-- Boutons Apple/Google Pay -->
          <div class="grid grid-cols-2 gap-3 mb-6">
            <div class="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
            <div class="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
          </div>

          <!-- Séparateur -->
          <div class="relative mb-6">
            <div class="w-full h-px bg-gray-200"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <div class="w-8 h-4 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>

          <!-- Formulaire -->
          <div class="space-y-6">
            <!-- Montant du don -->
            <div>
              <div
                class="w-24 h-3 bg-gray-200 rounded animate-pulse mb-2"
              ></div>
              <div class="grid grid-cols-3 gap-2 mb-3">
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
              </div>
              <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
            </div>

            <!-- Type de don -->
            <div>
              <div
                class="w-20 h-3 bg-gray-200 rounded animate-pulse mb-2"
              ></div>
              <div class="grid grid-cols-2 gap-2">
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
              </div>
            </div>

            <!-- Période d'abonnement -->
            <div>
              <div
                class="w-32 h-3 bg-gray-200 rounded animate-pulse mb-2"
              ></div>
              <div class="grid grid-cols-3 gap-2">
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
              </div>
            </div>

            <!-- Informations de carte -->
            <div>
              <div
                class="w-32 h-3 bg-gray-200 rounded animate-pulse mb-3"
              ></div>
              <div class="h-12 bg-gray-200 rounded-lg animate-pulse"></div>
              <div
                class="w-48 h-3 bg-gray-200 rounded animate-pulse mt-2"
              ></div>
            </div>

            <!-- Email -->
            <div>
              <div
                class="w-12 h-3 bg-gray-200 rounded animate-pulse mb-1"
              ></div>
              <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
              <div
                class="w-56 h-3 bg-gray-200 rounded animate-pulse mt-2"
              ></div>
            </div>

            <!-- Don anonyme et nom -->
            <div>
              <div class="flex items-center mb-3">
                <div class="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div
                  class="w-24 h-4 bg-gray-200 rounded animate-pulse ml-2"
                ></div>
              </div>
              <div
                class="w-20 h-3 bg-gray-200 rounded animate-pulse mb-1"
              ></div>
              <div class="h-9 bg-gray-200 rounded-lg animate-pulse"></div>
              <div
                class="w-full h-3 bg-gray-200 rounded animate-pulse mt-2"
              ></div>
            </div>

            <!-- Message de test -->
            <div class="w-48 h-4 bg-gray-200 rounded animate-pulse"></div>

            <!-- Option frais -->
            <div class="p-4 bg-gray-100 rounded-lg">
              <div class="flex items-start">
                <div
                  class="w-4 h-4 bg-gray-200 rounded animate-pulse mr-3 mt-1"
                ></div>
                <div class="flex-1">
                  <div
                    class="w-48 h-3 bg-gray-200 rounded animate-pulse mb-2"
                  ></div>
                  <div
                    class="w-full h-8 bg-gray-200 rounded animate-pulse"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Bouton paiement -->
            <div class="h-12 bg-gray-200 rounded-lg animate-pulse"></div>

            <!-- Message sécurité -->
            <div class="text-center">
              <div
                class="w-64 h-3 bg-gray-200 rounded animate-pulse mx-auto"
              ></div>
            </div>
          </div>

          <!-- Footer -->
          <div class="mt-6 text-center space-y-2">
            <div
              class="w-32 h-4 bg-gray-200 rounded animate-pulse mx-auto"
            ></div>
            <div class="flex justify-center space-x-4">
              <div class="w-24 h-3 bg-gray-200 rounded animate-pulse"></div>
              <div class="w-24 h-3 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Composant purement visuel, pas de logique
</script>
